import React from 'react';
import { Card, DatePicker, InputNumber, Radio, Row } from 'antd';
import FormInput from 'components/FormInput';
import ParListSelect from 'components/ParListSelect';
import { FormInstance } from 'antd/lib/form';
import UtinaCard from 'components/UtinaCard';
import GetLabel from 'DisplayFramework/components/GetLabel';

export type SpouseProps = {
  form: FormInstance;
};
const SpouseCard = (props: SpouseProps) => {
  return (
    <Card bordered title={<GetLabel label="spouse" style={{fontWeight:'bold',paddingLeft:15}} />}>
   
        <Row gutter={16}>
          <UtinaCard
            comcode="General Informations"
            level={5}
            lg={12}
            additionalAttribute
          >
            <FormInput col xs={20} lg={8} name="tpsalutationcode">
              <ParListSelect parcode="TPSALUT" />
            </FormInput>
            <FormInput col xs={20} lg={8} name="spgender">
              <Radio.Group>
                <Radio value="M">Male</Radio>
                <Radio value="F">Female</Radio>
              </Radio.Group>
            </FormInput>
            <FormInput col xs={20} lg={8} name="spname" />
            <FormInput col xs={20} lg={8} name="spsurname" />
            <FormInput col xs={20} lg={8} name="spmaidenname" />
            <FormInput col xs={20} lg={8} name="spbirthcity" />
            <FormInput col xs={20} lg={8} name="spbirthcountry">
              <ParListSelect parcode="COUNTRY" />
            </FormInput>

            <FormInput col xs={20} lg={8} name="spbirthdate">
              <DatePicker />
            </FormInput>
          </UtinaCard>

          <UtinaCard level={5} comcode="identity" lg={10} additionalAttribute>
            <FormInput col xs={20} lg={12} name="spidentitycardtype">
              <ParListSelect parcode="CARDTYPE" />
            </FormInput>
            <FormInput col xs={20} lg={12} name="spidentitycardid" />
            <FormInput col xs={24} lg={18} name="spfiscalid" />
          </UtinaCard>
          <UtinaCard level={5} comcode="employment" lg={7} additionalAttribute>
            <FormInput col xs={20} lg={20} name="spprofession">
              <ParListSelect parcode="PROFESSION" />
            </FormInput>
            <FormInput col xs={20} lg={20} name="spemployer" />
            <FormInput col xs={20} lg={20} name="spemployeraddress" />
            <FormInput col xs={20} lg={20} name="spemloyertel" />
          </UtinaCard>

          <UtinaCard level={5} comcode="income" lg={7} additionalAttribute>
            <FormInput col xs={20} lg={20} name="spmonthlyincome">
              <InputNumber />
            </FormInput>
            <FormInput col xs={20} lg={20} name="spothersincome">
              <InputNumber />
            </FormInput>
          </UtinaCard>

          <UtinaCard level={5} comcode="expenses" lg={7} additionalAttribute>
            <FormInput col xs={20} lg={20} name="spotherloan">
              <InputNumber />
            </FormInput>
            <FormInput col xs={20} lg={20} name="spothersexpense">
              <InputNumber />
            </FormInput>
          </UtinaCard>
        </Row>
      </Card>

  );
};

export default SpouseCard;
